import React, { useEffect, useState } from "react";
import { Avatar, Skeleton, Space } from "antd";
import { useRouter } from "next/navigation";
import { BiSolidChevronsDown } from "react-icons/bi";
import { BsBookshelf } from "react-icons/bs";
import SliderArtist from "@/components/slider-artist";
import { HiOutlineBookOpen, HiOutlineBookmark } from "react-icons/hi2";
import { DesCard, HeadModule } from "@/layouts/styles/ssr.style";
import Image from "next/image";
import { definitions } from "@/services/metruyenvl";
import authAPI from "@/services/auth_api";
import authorAPI from "@/services/author_api";
import { ResponseTypes } from "@/types/constants";
import { statAPI } from "@/services/stat_api";
import { formatValueReadings } from "@/utils/formatted";

function CardArtist({ book }: { book?: definitions["do.BookDO"] }) {
    const [statAuthor, setStatAuthor] = useState<definitions["do.StatsDO"]>();
    const router = useRouter();

    return (
        <div className="w-full h-auto rounded-lg p-4 text-center overflow-hidden md:mt-0 mt-4" style={{ background: "#f7f5f0" }}>
            <div
                onClick={() => {
                    router.push(`/tac-gia/${book?.author?.slug}`);
                }}
                className="cursor-pointer"
            >
                <Avatar size={80} icon={<Image unoptimized={true} loader={() => book?.author?.avatar ?? "/avatar.gif"} src={book?.author?.avatar ?? "/avatar.gif"} alt="" height={120} width={120} />} />
                <HeadModule styles={{ marginTop: "10px" }}>{book?.author?.name ? book?.author?.name : <Skeleton.Input active size="small" />}</HeadModule>
            </div>
            <div className="flex justify-evenly">
                <div className="flex flex-col items-center">
                    <HiOutlineBookOpen color="#b78f60" size={24} />
                    <DesCard styles={{ margin: "10px 0px" }}>Số truyện</DesCard>
                    <span className="text-xl font-semibold">{book?.author?.stats ? book?.author?.stats?.books_count : <Skeleton.Button active size="small" />}</span>
                </div>
                <div className="flex flex-col items-center">
                    <BsBookshelf color="#b78f60" size={24} />
                    <DesCard styles={{ margin: "10px 0px" }}>Số chương</DesCard>
                    <span className="text-xl font-semibold">{book?.author?.stats ? formatValueReadings(book?.author?.stats?.chapters_count ?? 0) : <Skeleton.Button active size="small" />}</span>
                </div>
                <div className="flex flex-col items-center">
                    <BiSolidChevronsDown color="#b78f60" size={24} />
                    <DesCard styles={{ margin: "10px 0px" }}>Cấp</DesCard>
                    <span className="text-xl font-semibold">1</span>
                </div>
            </div>
            <div className="mt-5 h-[450px] overflow-hidden w-full">
                <SliderArtist book={book} />
            </div>
        </div>
    );
}

export default React.memo(CardArtist);
